import { render, staticRenderFns } from "./typelist.vue?vue&type=template&id=6fed4e5e&scoped=true&"
import script from "./typelist.vue?vue&type=script&lang=js&"
export * from "./typelist.vue?vue&type=script&lang=js&"
import style0 from "./typelist.vue?vue&type=style&index=0&id=6fed4e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed4e5e",
  null
  
)

export default component.exports